import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import OfficeInfo from "./OfficeInfo";
import RegisterModal from "./RegisterModal";
import FullScreenMessage from "./FullScreenMessage";
import "./AvailableTimes.css";
import moment from 'moment-timezone';
import { cqAPI } from "../lib/Auth";
import { sendEvent } from "../lib/GA";

const Availabilities = () => {
  const { serviceId, date } = useParams();
  const [hasError, setHasError] = useState(false);
  const day = date.replace(/-/g, "/");
  const navigate = useNavigate();
  const location = useLocation();
  const [availability, setAvailability] = useState([]);
  const [service, setService] = useState({});
  const [officeData, setOfficeData] = useState({});
  const [isLoading, setIsLoading] = useState(true); // State to handle loading
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false); // New state for the confirmation modal
  const [serverMessage, setServerMessage] = useState("");
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    dob: undefined,
    gender: undefined,
    terms: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setIsLoading(true); // Start loading
    const locationParams = new URLSearchParams(location.search);
    const timepref = locationParams.get('timepref');
    const searchParams = new URLSearchParams({
      service_id: serviceId,
      day,
      ...(timepref ? {timepref} : {})
    });
    cqAPI
      .get(`/times?${searchParams.toString()}`)
      .then((data) => {
        if (data.type === "ok") {
          setAvailability(data.data.availabilities);
          setService(data.data.service);
          setOfficeData(data.data.business);
        } else {
          if (data.code) {
            setHasError(true);
          }
        }
        setIsLoading(false); // Stop loading
      })
      .catch((error) => {
        setHasError(true);
        setIsLoading(false); // Stop loading even on error
        console.error('Loading error', error);
      });
  }, [serviceId, day, location.search]);

  if (hasError) {
    return <FullScreenMessage message="This is not a valid link" />;
  }

  if (isLoading) {
    return (
      <div className="spinner-container">
        <div className="spinner"></div>
      </div>
    );
  }
  const handleDayClick = (timeInfo) => {
    setSelectedTimeSlot(timeInfo); // Save the clicked time slot information
    setIsModalOpen(true); // Open the modal
  };

  const changeDay = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('timepref');

    navigate({
      pathname: `/service/${serviceId}`,
      search: `?${searchParams.toString()}`
    });
  };

  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleRegister = () => {
    // Handle the registration logic here with formData
    setIsSubmitting(true);
    cqAPI.post('/book?author_entity=booking-app', {
      name: formData.fullName,
      phone: formData.phoneNumber,
      email: formData.email,
      dob: formData.dob,
      gender: formData.gender,
      appointment: { ...selectedTimeSlot, note: `Insurance: ${formData.insurance}`, booked_at: new Date() }
    }).then(data => {
      setIsSubmitting(false);
      if (data.type === 'ok') {
        setIsModalOpen(false);
        sendEvent("signupbooked", {}, true);
        if (data.msg) {
          setServerMessage(data.msg); // Store the server message
          setIsConfirmModalOpen(true);
        }
      }
    }).catch(error => {
      console.error('Error: ', error);
      setIsModalOpen(false);
    })
  };

  return (
    <div className="availability-container availability-day">
      <OfficeInfo info={officeData} />
      <p className="instruction selected-day">
        {service.name} on {moment(new Date(day)).tz(officeData.zone).format("LL")}
      </p>
      <p className="instruction">
        Select the time. You will review and confirm next.
      </p>
      <div
        className="service-header"
        style={{ borderBottom: "0px !important" }}
      >
        <span></span>
        <span className="change-service" onClick={changeDay}>
          Change Date
        </span>
      </div>
      {availability.map((dayInfo, index) => (
        <div
          key={index}
          className="day-block"
          onClick={() => handleDayClick(dayInfo)}
        >
          <div className="provider-info">
            <img
              src={dayInfo.img}
              alt={dayInfo.name}
              className="provider-img"
            />
            <div>
              <h4>
                {dayInfo.title ? dayInfo.title + " " : ""}
                {dayInfo.name}
              </h4>
              <p>{dayInfo.time}</p>
            </div>
          </div>
        </div>
      ))}
      {isModalOpen && (
        <RegisterModal
          formData={formData}
          onChange={handleInputChange}
          onRegister={handleRegister}
          serviceName={service.name}
          tc={officeData.tc}
          pmsType={officeData.pms_type}
          onClose={() => setIsModalOpen(false)}
          isSubmitting={isSubmitting}
        />
      )}
      {isConfirmModalOpen && (<div className="modal-overlay">
      <div className="modal-content">
        <p>{serverMessage}</p>
      </div>
    </div>)}
    </div>
  );
};

export default Availabilities;
